<template>
  <div>
    <b-row class="toolbar-ptc">
      <b-col class="text-center title">線上點餐管理 / 商品分類設定</b-col>
    </b-row>

    <div id="func-content">
      <b-card class="bg-default-card">
          <div class="row">
            <div class="col-lg-12">
              <div class="p-4 box-shadow">
                <div class="row">
                  <label class="control-label col-md-2 mt-2">品牌：</label>
                  <div class="col-md-4">
                    <select
                      name="queryBrandsCode"
                      class="form-control"
                      v-model="search.queryBrandsCode"
                    >
                    <option
                      v-for="x in selectListBrands"
                      v-bind:value="x.Code"
                      :key="x.Code"
                    >{{x.Text}}</option>
                    </select>
                  </div>
                  <div class="col-md-3">
                    <button type="button" class="btn btn-ptc1" @click="btnQuery">查詢</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-card>
      <b-card class="bg-default-card">
        <div class="row">
          <div class="col-lg-12">
                <div class="row">
                  <div class="col-lg-12">
                    <vue-form class="form-horizontal form-validation" :state="formstate" @submit.prevent="onSubmit_APP">
                                                <div class='float-right'>
                                                    <div class='float-right'>
                                                        <table>
                                                            <tr>
                                                                <td v-if='!btn_add' colspan="3">
                                                                    <label>{{editOldAppTypeName}}</label>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td v-if='!btn_add'>
                                                                    <label>{{iAppTypeStatusDesc}}{{afterClickBrandsCode}}_APP分類名稱：</label>
                                                                </td>
                                                                <td v-if='!btn_add'>
                                                                    <validate tag="div">
                                                                        <input type='text' name='InputName' class='form-control' v-model.trim='editAppTypeName' ref="rAppTypeName" maxlength="6" required>
                                                                        <field-messages name="InputName" show="$invalid && $submitted" class="text-danger">
                                                                            <div slot="required">請輸入APP分類名稱</div>
                                                                        </field-messages>
                                                                    </validate>
                                                                </td>
                                                                <td>
                                                                    <button type='button' class='btn btn-outline-light' v-show='btn_order && btn_add && FunctionPermission > 1' @click='addAppTypeBy'>新增APP分類</button>
                                                                    <button type='button' class='btn btn-warning text-white' v-show='btn_order && btn_add && FunctionPermission > 1' @click='editOrderBy'>重新排序</button>

                                                                    <button type='submit' class='btn btn-save' v-show='!btn_add && FunctionPermission > 1'>儲存</button>
                                                                    <button type='reset' class='btn btn-clear' v-show='!btn_add && FunctionPermission > 1' @click='editAppTypeCancel'>取消</button>
                                                                    <!-- 排序用按鈕 -->
                                                                    <button type='button' class='btn btn-save' v-show='!btn_order && FunctionPermission > 1' @click='orderAppTypeSave'>儲存</button>
                                                                    <button type='button' class='btn btn-clear' v-show='!btn_order && FunctionPermission > 1' @click='orderAppTypeCancel'>取消</button>
                                                                </td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </div>
                    </vue-form>
                  </div>
                  <div class="col-lg-12 mt-2">
                    <table id='AppTypeTable' class='table table-bordred table-striped'>
                                                <thead>
                                                    <tr>
                                                        <th style="width:15%">序號</th>
                                                        <th style="width:20%">品牌</th>
                                                        <th style="width:35%">分類名稱</th>
                                                        <th style="width:30%"></th>
                                                    </tr>
                                                </thead>
                                                <draggable v-model='listAppType' element='tbody' :options="dragOptions" @update="dragEnd">
                                                    <tr v-for='(x, index) in listAppType' :key='x.id'>
                                                        <td>{{index + 1}}</td>
                                                        <td>{{x.brandCode}}</td>
                                                        <td>{{x.name}}</td>
                                                        <td>
                                                            <button class='btn btn-outline-primary btn_width btn_rounded mt-3' @click='editAppTypeBy(index)' v-show='FunctionPermission > 1 && btn_order'>名稱修改</button>
                                                            <router-link tag="a" :to="{ name: 'menu_item_list', params: { menuid: x.id, menuname: x.name, brandCode:x.brandCode } }" class="btn btn-outline-success btn_width btn_rounded mt-3"  v-show='btn_order'>商品維護</router-link>
                                                            <button v-if='!x.hasdetail' class='btn btn-outline-danger btn_width btn_rounded mt-3' v-show='FunctionPermission > 1 && btn_order' @click='delAppTypeByOpen(index)'><span class='fas fa-trash-alt' title="刪除"></span></button>
                                                        </td>
                                                    </tr>
                                                </draggable>
                    </table>
                    <b-modal ref='editAppTypeModal' hide-footer :title='modalTitleForAPPType'>
                                            <b-container fluid>
                                                <div class='row mt-3' style='text-align:center;'>
                                                    <label class='control-label'>確認{{this.iAppTypeStatusDesc}}「{{editAppTypeName}}」?</label>
                                                </div>
                                                <div class='float-right'>
                                                    <b-btn variant='primary' @click='editAppTypeModalSave'>確認</b-btn>
                                                    <b-btn variant='secondary' @click='editAppTypeModalCancel'>取消</b-btn>
                                                </div>
                                            </b-container>
                    </b-modal>
                  </div>
                </div>

          </div>
        </div>
      </b-card>

      <!-- ReSort Check Modal -->
      <b-modal ref="mdCheck" hide-footer title="排序變更">
        <b-container fluid>
          <form>
            <div class="row mb-3">
              <label class="control-label">確定 {{sort_action==1? '放棄' : '儲存'}} 排序變更 ?</label>
            </div>
            <div class="float-right">
              <b-btn variant="primary" @click="orderAppTypeConfirm">確定</b-btn>
              <b-btn variant="secondary" @click="orderCancel">取消</b-btn>
            </div>
          </form>
        </b-container>
      </b-modal>

    </div>
  </div>
</template>
<script src="//cdnjs.cloudflare.com/ajax/libs/vue/2.5.2/vue.min.js"></script>
<script src="//cdn.jsdelivr.net/npm/sortablejs@1.7.0/Sortable.min.js"></script>
<script src="//cdnjs.cloudflare.com/ajax/libs/Vue.Draggable/2.15.0/vuedraggable.min.js"></script>
<script>
import {getFunctionPermission} from '../../../js/LoginUserFunction.js'
import {API_URL} from '../../../store/root.js'
import miniToastr from 'mini-toastr'
import draggable from 'vuedraggable'
import VModal from 'vue-js-modal'
import axios from 'axios'
miniToastr.init()
export default {
  components: {
    draggable
  },
  data () {
    return {
      sort_action: 1,
      sort_list: [],
      API_URL: API_URL,
      FunctionPermission: 0,
      search:{
        queryBrandsCode: "MWD",
      },
      afterClickBrandsCode: "",
      selectListBrands: [], // 品牌下拉選單
      //-------APP分類設定 (AppType)-------------start
      sort_disabled: true, // 排序功能是否停用
      listAppType: [], // 列表
      modalTitleForAPPType: "", // APP分類設定 - Modal的title
      btn_order: true, // 上方[重新排序]按鈕是否顯示
      btn_add: true, // 上方[新增APP分類按鈕]按鈕是否顯示
      // 上方編輯功能
      formstate: {}, // 驗證用
      iAppTypeStatusDesc: "", // 是新增or修改or刪除
      iAppTypeStatus: 0, // 新增or修改or刪除
      editAppTypeName: "", // Input APP分類名稱
      editOldAppTypeName: "", // 原APP分類名稱
      editAppTypeID: "" // 目前編輯/刪除的ID
      //-------APP分類設定 (AppType)-------------end
    }
  },
  created () {
    this.FunctionPermission = getFunctionPermission('F18') // 功能權限
    if (this.FunctionPermission < 1) {
      this.$router.push({ name: 'name' })
      return
    }
    var paramsSearch = this.$route.params.brandCode;
    if (paramsSearch !== undefined) {
        this.search.queryBrandsCode = paramsSearch;
        this.query()
    } else {
      this.reset();
    }
    this.querySelectListBrands()
  },
  methods: {
    reset () {
      this.query()
    },
    btnQuery () {
      this.query()
    },
    query () {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/shopping/getmenu/v1',{
        BrandCode: this.search.queryBrandsCode,
      })
        .then((response) => {
          // console.log(response.data)
          this.$store.commit('TOKEN', response.data.jwt)
          this.listAppType = response.data.data
          if (response.data.result === '0000') {
            this.listAppType = response.data.data
            this.afterClickBrandsCode = this.search.queryBrandsCode
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            this.listAppType = []
            miniToastr.error(response.data.message, '資料讀取異常')
            // console.log(response.data.message)
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          miniToastr.error('5')
          this.listAppType = []
          this.$parent.Loading = false
          miniToastr.error(error, '資料讀取異常')
          console.log(error)
        })
    },
    onSubmit_APP: function () {
      if (this.formstate.$invalid) {
      } else {
        this.openEditAppTypeModal()
      }
    },
    // APP分類設定 - Modal的增刪改
    editAppTypeModalSave () {
            if (!this.btn_add) {
                if (this.iAppTypeStatus === 1) { // 新增
                    this.$parent.Loading = true
                    return axios.post(API_URL + '/web/shopping/menuCreate', {
                        name: this.editAppTypeName,
                        brandCode: this.afterClickBrandsCode,
                    })
                        .then((response) => {
                            if (response.data.result === '0000') {
                                miniToastr.success('新增成功')
                                this.editAppTypeModalReset()
                                this.query()
                            } else {
                                if (response.data.result === '0006') {
                                    this.$parent.logOut(false, true)
                                } else {
                                    miniToastr.error(response.data.message, '錯誤訊息')
                                }
                                this.$refs.editAppTypeModal.hide()
                                this.$refs.rAppTypeName.focus()
                            }
                            this.$parent.Loading = false
                        })
                        .catch((error) => {
                            miniToastr.error(error, 'Error')
                            this.$parent.Loading = false
                        })
                } else if (this.iAppTypeStatus === 2) { // 修改
                    this.$parent.Loading = true
                    return axios.post(API_URL + '/web/shopping/menuUpdate', {
                        id: this.editAppTypeID,
                        name: this.editAppTypeName
                    })
                        .then((response) => {
                            if (response.data.result === '0000') {
                                miniToastr.success('修改成功')
                                this.editAppTypeModalReset()
                                this.query()
                            } else {
                                if (response.data.result === '0006') {
                                    this.$parent.logOut(false, true)
                                } else {
                                    miniToastr.error(response.data.message, '錯誤訊息')
                                }
                                this.$refs.editAppTypeModal.hide()
                                this.$refs.rAppTypeName.focus()
                            }
                            this.$parent.Loading = false
                        })
                        .catch((error) => {
                            miniToastr.error(error, '錯誤訊息')
                            this.$parent.Loading = false
                        })
                }
            }
            // 刪除
            if (this.iAppTypeStatus === 3) {
              this.$parent.Loading = true
              return axios.post(API_URL + '/web/shopping/menuDelete', {
                  id: this.editAppTypeID
              })
                .then((response) => {
                    if (response.data.result === '0000') {
                        miniToastr.success('刪除成功')
                        this.editAppTypeModalReset()
                        this.query()
                        localStorage.setItem('TOKEN', response.data.jwt)
                    } else {
                        if (response.data.result === '0006') {
                            this.$parent.logOut(false, true)
                        } else {
                            miniToastr.error(response.data.message, '錯誤訊息')
                        }
                        this.$refs.editAppTypeModal.hide()
                    }
                    this.$parent.Loading = false
                })
                .catch((error) => {
                    miniToastr.error(error, '錯誤訊息')
                    this.$parent.Loading = false
                })
            }
    },
    // APP分類設定 - Modal的重設
        editAppTypeModalReset () {
            this.btn_add = true;
            this.btn_order = true;
            this.editAppTypeName = "";
            this.$refs.editAppTypeModal.hide();
        },
        // APP分類設定 - Modal的取消
        editAppTypeModalCancel () {
            this.$refs.editAppTypeModal.hide();
        },
    // APP分類設定 - 按下[新增APP分類]按鈕
    addAppTypeBy () {
      this.iAppTypeStatus = 1;
      this.iAppTypeStatusDesc = "新增";
      this.btn_add = false;
      this.editAppTypeName = "";
      this.editOldAppTypeName = "";
      this.modalTitleForAPPType = "新增APP分類";
      if (this.afterClickBrandsCode != this.search.queryBrandsCode){
        this.query()
      }
    },
    //APP分類設定 - 按下列表編輯按鈕
    editAppTypeBy (index) {
      this.iAppTypeStatus = 2;
      this.iAppTypeStatusDesc = "修改";
      // this.iAppTypeIndex = index;
      this.editAppTypeID = this.listAppType[index].id;
      this.editAppTypeName = this.listAppType[index].name;
      this.editOldAppTypeName = "原名稱：" + this.listAppType[index].name;
      this.btn_add = false;
      this.modalTitleForAPPType = "修改APP分類";
    },
    //APP分類設定 - 按下列表刪除按鈕
    delAppTypeByOpen (index) {
      this.iAppTypeStatus = 3;
      this.iAppTypeStatusDesc = "刪除";
      // this.iAppTypeIndex = index;
      this.editAppTypeID = this.listAppType[index].id;
      this.editAppTypeName = this.listAppType[index].name;
      this.modalTitleForAPPType = "刪除APP分類";
      this.openEditAppTypeModal()
    },
    // APP分類設定 - 取消
    editAppTypeCancel () {
      this.btn_add = true;
      this.btn_order = true;
      this.editAppTypeName = "";
    },
    // APP分類設定 - 開啟是否要'增/刪/改'詢問視窗
    openEditAppTypeModal () {
      this.$refs.editAppTypeModal.show();
    },
    // APP分類設定 - 按下重新排序按鈕
    editOrderBy () {
      this.btn_order = false;
      this.sort_disabled = false; // 啟用排序
      this.sort_list = []
    },
    // APP分類設定 - 儲存新的排序
    orderAppTypeConfirm () {
      this.$refs.mdCheck.hide()

            // 取得id與新的排序
            var arrAll = []
            this.listAppType.forEach(function (arrRole, Index) {
                arrAll.push({
                    id: arrRole.id,
                    sort: Index + 1
                })
            })
            // call API
            this.$parent.Loading = true
            return axios.post(API_URL + '/web/shopping/menuOrder/v1', {
                data: arrAll,
                brandCode: this.afterClickBrandsCode,
            })
                .then((response) => {
                    if (response.data.result === '0000') {
                        miniToastr.success('重新排序成功')
                        this.sort_disabled = true; // 停用排序
                        this.editAppTypeModalReset()
                        this.query(3)
                    } else {
                        if (response.data.result === '0006') {
                            this.$parent.logOut(false, true)
                        } else {
                            miniToastr.error(response.data.message, '錯誤訊息')
                        }
                    }
                    this.$parent.Loading = false
                })
                .catch((error) => {
                    miniToastr.error(error, '錯誤訊息')
                    this.$parent.Loading = false
                })

    },
    // APP分類設定 - 排序取消
    orderAppTypeCancel () {
      this.btn_add = true;
      this.btn_order = true;
      this.sort_disabled = true; // 停用排序

      if (this.sort_list.length > 0) {
        this.query()
      }
    },
    dragEnd (e) {
      this.sort_list = []
      var childs = Array.from(e.to.getElementsByTagName("tr"))
      childs.forEach((value) => {
        this.sort_list.push(value.id)
      })
    },
    orderAppTypeSave () {
      this.sort_action = 2
      if (this.sort_list.length === 0) {
        this.btn_order = true
        this.query()
      } else {
        this.$refs.mdCheck.show()
      }
    },
    orderCancel () {
      this.$refs.mdCheck.hide()
    },
    querySelectListBrands() {
      //品牌下拉選單
      axios
        .post(API_URL + "/web/brands/v1", {
          all: false,
          order: true
        })
        .then(response => {
          this.selectListBrands = response.data.data;
          this.$parent.Loading = false;
        })
        .catch(error => {
          this.selectListBrands = [];
          this.$parent.Loading = false;
          miniToastr.error(error, "資料讀取異常");
          console.log(error);
        });
    }
  },
  computed: {
        // 排序參數設定
        dragOptions () {
            return {
                disabled: this.sort_disabled,
            }
        },
    }
}
</script>
<style scoped>
.table-move>tbody>tr {
  cursor: move;
}
</style>



// WEBPACK FOOTER //
// src/pages/shopping/menu/List.vue